import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { NotFoundComponent } from '@shared/pages/not-found/not-found.component';
import { PaymentRequiredComponent } from '@shared/pages/payment-required/payment-required.component';
import publicRoutes from './components/public/public.routes';
import { TelegramAltaComponent } from './components/public/telegram-alta/telegram-alta.component';

export const routes: Routes = [
	{
		// Mini App: no public layout, so nothing can swallow Telegram's hash (RT17-01).
		path: 'tg/alta',
		component: TelegramAltaComponent,
	},
	{
		path: '',
		children: publicRoutes,
	},
	{
		path: '',
		canMatch: [
			() => {
				const token = inject(AuthService).getToken();
				return !!token; // Allow all authenticated users
			},
		],
		loadChildren: () => import('./components/backoffice/backoffice.routes'),
	},
	{
		path: 'account',
		canMatch: [
			() => {
				return !!inject(AuthService).getToken();
			},
		],
		loadChildren: () => import('./components/backoffice/account/account.routes'),
	},
	{
		path: 'payment-required',
		component: PaymentRequiredComponent,
	},
	{
		path: '**',
		component: NotFoundComponent,
	},
];
